import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, Grid } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { UAParser } from 'ua-parser-js';

const UserAgentParser = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');

  const handleAction = () => {
    try { const parser = new UAParser(input); setOutput(JSON.stringify(parser.getResult(), null, 2)); } catch(e) { setOutput(e.message); }
  };

  const handleClear = () => {
    setInput('');
    setOutput('');
  };

  const handleCopy = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      // Optional: Add a toast notification here
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 130px)', animation: 'fadeIn 0.5s ease-in-out' }}>
      <Paper elevation={3} sx={{ p: 1.5, borderRadius: 2, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          User-Agent Parser
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Parse User-Agent strings.
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, flexGrow: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, width: { md: '50%' } }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: 'primary.light' }}>
              Input Data
            </Typography>
            <TextField
              fullWidth
              multiline
              variant="outlined"
              placeholder="Enter your input here..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              sx={{ position: 'relative', flexGrow: 1, '& .MuiInputBase-root': { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, alignItems: 'flex-start', overflow: 'auto' }, '& textarea': { height: '100% !important' } }}
              InputProps={{ 
                sx: { 
                  fontFamily: 'monospace', 
                  fontSize: '0.9rem',
                  bgcolor: 'background.default',
                  boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)'
                } 
              }}
            />
            <Box sx={{ mt: 1.5, display: 'flex', gap: 1.5 }}>
              <Button 
                variant="contained" 
                color="primary" 
                startIcon={<PlayArrowIcon />} 
                onClick={handleAction}
              >
                Execute
              </Button>
              <Button 
                variant="outlined" 
                color="secondary" 
                startIcon={<DeleteSweepIcon />} 
                onClick={handleClear}
              >
                Clear
              </Button>
            </Box>
          </Box>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, width: { md: '50%' } }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: 'secondary.light' }}>
              Output Result
            </Typography>
            <TextField
              fullWidth
              multiline
              variant="outlined"
              placeholder="Result will appear here..."
              value={output}
              sx={{ position: 'relative', flexGrow: 1, '& .MuiInputBase-root': { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, alignItems: 'flex-start', overflow: 'auto' }, '& textarea': { height: '100% !important' } }}
              InputProps={{ 
                readOnly: true,
                sx: { 
                  fontFamily: 'monospace', 
                  fontSize: '0.9rem',
                  bgcolor: 'background.default',
                  boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)'
                } 
              }}
            />
            <Box sx={{ mt: 1.5, display: 'flex', justifyContent: 'flex-end' }}>
              <Button 
                variant="outlined" 
                startIcon={<ContentCopyIcon />} 
                onClick={handleCopy}
              >
                Copy Output
              </Button>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default UserAgentParser;
